module.exports = __webpack_public_path__ + "static/media/chroniclr.c17ce86b.png";